import React from 'react';
import {Layer} from "react-map-gl/mapbox";
import {CircleLayerSpecification, SymbolLayerSpecification} from "mapbox-gl";

// Types ----

type VisitorMovementLayerProps = {
  id: string
  source?: string
  selectedPoint: number
}

// Component ----

function VisitorMovementLayer({id, source, selectedPoint}: VisitorMovementLayerProps) {
  return (
    <>
      <Layer
        id={`${id}-circle`}
        source={source}
        type="circle"
        minzoom={10}
        paint={{...circlePaint, 'circle-color': [
            'case',
            ['==', ['get', 'point'], selectedPoint],
            '#f59e0b',
            '#cccccc'
        ]}}
      />

      <Layer
        id={`${id}-point-label`}
        source={source}
        type="symbol"
        minzoom={14}
        paint={{...pointLabelPaint, 'text-color': [
            'case',
            ['==', ['get', 'point'], selectedPoint],
            'white',
            '#666666'
          ]}}
        layout={pointLabelLayout}
      />

      <Layer
        id={`${id}-time-label`}
        source={source}
        type="symbol"
        minzoom={16}
        paint={timeLabelPaint}
        layout={timeLabelLayout}
      />
    </>
  );
}

// Styles ----

const pointLabelLayout: SymbolLayerSpecification['layout'] = {
  "text-field": ["get", "point"],
  "text-anchor": "center",
  "text-size": [
    "interpolate",
    ["linear"],
    ["zoom"],
    10, 1,
    16, 14,
    23, 32,
  ],
  "text-font": ["Open Sans SemiBold"],
}

const timeLabelLayout: SymbolLayerSpecification['layout'] = {
  "text-field": ["get", "occurred_at_tz"],
  "text-anchor": "bottom",
  "text-size": [
    "interpolate",
    ["linear"],
    ["zoom"],
    10, 1,
    16, 12,
    23, 24,
  ],
  "text-offset": [
    "interpolate",
    ["linear"],
    ["zoom"],
    16, [0, 2.4],
    23, [0, 4],
  ],
}

const circlePaint: CircleLayerSpecification['paint'] = {
  'circle-stroke-color': 'white',
  'circle-stroke-width': 1,
  "circle-radius": [
    "interpolate",
    ["linear"],
    ["zoom"],
    10, 0.5,
    16, 10,
    23, 38,
  ],
};

const pointLabelPaint: SymbolLayerSpecification['paint'] = {
  "text-color": "white",
}

const timeLabelPaint: SymbolLayerSpecification['paint'] = {
  "text-halo-width": 2,
  "text-halo-color": "#FFFFFF",
}



// Export ----

export default VisitorMovementLayer;
